import React from 'react'
import Header from './Header'
import Footer from './Footer'
import { Box } from '@material-ui/core'
import makeStyles from '@material-ui/core/styles/makeStyles'
import { rootStyles } from '../themeStyles'

const useStyles = makeStyles((theme) => ({ ...rootStyles }))

const Layout = ({
    children,
    baseUrl,
    brandLogoUrl,
    footerContent,
    step,
    footerContentHidden,
}) => {
    const classes = useStyles()

    return (
        <>
            <Header step={step} baseUrl={baseUrl} logoImage={brandLogoUrl} />
            <Box className={classes.root}>{children}</Box>
            {!footerContentHidden && (
                <Footer baseUrl={baseUrl} content={footerContent} />
            )}
        </>
    )
}

export default Layout
